module.exports = __webpack_public_path__ + "static/media/ImgGroupUpload.ece1d006.svg";